// Umwandlungswahl über dem Brett (Dame, Turm, Läufer, Springer), für Analyse und Spielmodus.
import { h, type VNode } from 'snabbdom';
import { t } from '../i18n';
import { roleName } from '../roles';

export type PromotionRole = 'q' | 'r' | 'b' | 'n';
const ROLES: [PromotionRole, string][] = [['q', 'queen'], ['r', 'rook'], ['b', 'bishop'], ['n', 'knight']];

/** pick(null) = abbrechen (Klick neben die Figuren) */
export function promotionView(color: 'white' | 'black', pick: (role: PromotionRole | null) => void): VNode {
  return h('div.promotion', { on: { click: () => pick(null) } }, [
    h('div.cg-wrap.choices', ROLES.map(([r, name]) =>
      h('button', {
        attrs: { 'aria-label': t('Umwandeln in {p}', { p: roleName(name) }) },
        on: { click: (e: Event) => (e.stopPropagation(), pick(r)) },
      }, h(`piece.${name}.${color}`)))),
  ]);
}
